export enum DirectDebitStatus {
  Unknown,
  ToBeProcessed,
  Retry,
  Failed,
  Success,
}
